if (!customElements.get('collapsible-text')) {
  customElements.define(
    'collapsible-text',
    class CollapsibleText extends HTMLElement {
      connectedCallback() {
        this.clip = this.querySelector('.collapsible-text__clip');
        this.toggle = this.querySelector('.collapsible-text__toggle');
        if (!this.clip || !this.toggle) return;

        this.moreLabel = this.toggle.getAttribute('data-label-more') || '';
        this.lessLabel = this.toggle.getAttribute('data-label-less') || '';

        this.onToggle = this.onToggle.bind(this);
        this.evaluate = this.evaluate.bind(this);
        this.toggle.addEventListener('click', this.onToggle);
        window.addEventListener('resize', this.evaluate);

        this.evaluate();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.evaluate);
      }

      evaluate() {
        // Keep an expanded block open across resizes.
        if (this.classList.contains('is-expanded')) return;

        const overflowing = this.clip.scrollHeight - this.clip.clientHeight > 2;
        this.classList.toggle('is-static', !overflowing);
        this.toggle.hidden = !overflowing;
      }

      onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.setAttribute('aria-label', expanded ? this.lessLabel : this.moreLabel);
      }
    }
  );
}
